/**
 * @generated SignedSource<<122994fce0a2ade6d163e4e3341ddd92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlogPostSignedIn_BlogPost$data = {
  readonly id: string;
  readonly slug: string | null | undefined;
  readonly title: string | null | undefined;
  readonly user: {
    readonly id: string;
    readonly profile: {
      readonly slug: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BlogPostContent_BlogPost" | "MetaInfo_BlogPostFragment" | "ProfileHireBox_BlogPostFragment">;
  readonly " $fragmentType": "BlogPostSignedIn_BlogPost";
};
export type BlogPostSignedIn_BlogPost$key = {
  readonly " $data"?: BlogPostSignedIn_BlogPost$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogPostSignedIn_BlogPost">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlogPostSignedIn_BlogPost",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BlogPostContent_BlogPost"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MetaInfo_BlogPostFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileHireBox_BlogPostFragment"
    }
  ],
  "type": "BlogPost",
  "abstractKey": null
};
})();

(node as any).hash = "9e7de7fa76fe3f05a4b9c91c0e09872c";

export default node;
